import type { Transaction, Labels } from '../../types/accountReceivable';
import { TransactionRow } from './TransactionRow';

interface TransactionListProps {
  transactions: Transaction[];
  labels: Labels;
  loading: boolean;
  hasMore: boolean;
  onLoadMore: () => void;
}

export function TransactionList({ transactions, labels, loading, hasMore, onLoadMore }: TransactionListProps) {
  if (transactions.length === 0 && !loading) {
    return (
      <div className="rounded-lg bg-gray-50 px-5 py-10 text-center text-gray-500">
        <p>{labels.noTransactions}</p>
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-xl border border-gray-200 bg-white">
      {/* Desktop header */}
      <div
        className="hidden border-b border-gray-200 bg-gray-50 px-4 py-3 text-xs font-semibold uppercase tracking-wide text-gray-500 md:grid"
        style={{ gridTemplateColumns: '100px 100px 1fr 120px 120px 80px', gap: '12px' }}
      >
        <div>{labels.date}</div>
        <div>{labels.type}</div>
        <div>{labels.description}</div>
        <div className="text-right">{labels.amount}</div>
        <div className="text-right">{labels.runningBalance}</div>
        <div className="text-center">Acciones</div>
      </div>

      <div>
        {transactions.map((t) => (
          <TransactionRow key={t.id} transaction={t} labels={labels} />
        ))}
      </div>

      {hasMore && (
        <div className="border-t border-gray-100 p-4 text-center">
          <button
            onClick={onLoadMore}
            disabled={loading}
            className="rounded-md bg-green-500 px-6 py-2.5 text-sm font-medium text-white transition-colors hover:bg-green-600 disabled:cursor-not-allowed disabled:opacity-70"
          >
            {loading ? labels.loading : labels.loadMore}
          </button>
        </div>
      )}
    </div>
  );
}
